import { render, staticRenderFns } from "./ShareRoutes.vue?vue&type=template&id=76317bee"
import script from "./ShareRoutes.vue?vue&type=script&lang=js"
export * from "./ShareRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports